var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvitecopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6084_17779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 0.832031H3.33317C2.4165 0.832031 1.6665 1.58203 1.6665 2.4987V13.332C1.6665 13.7904 2.0415 14.1654 2.49984 14.1654C2.95817 14.1654 3.33317 13.7904 3.33317 13.332V3.33203C3.33317 2.8737 3.70817 2.4987 4.1665 2.4987H12.4998C12.9582 2.4987 13.3332 2.1237 13.3332 1.66536C13.3332 1.20703 12.9582 0.832031 12.4998 0.832031ZM15.8332 4.16536H6.6665C5.74984 4.16536 4.99984 4.91536 4.99984 5.83203V17.4987C4.99984 18.4154 5.74984 19.1654 6.6665 19.1654H15.8332C16.7498 19.1654 17.4998 18.4154 17.4998 17.4987V5.83203C17.4998 4.91536 16.7498 4.16536 15.8332 4.16536ZM14.9998 17.4987H7.49984C7.0415 17.4987 6.6665 17.1237 6.6665 16.6654V6.66536C6.6665 6.20703 7.0415 5.83203 7.49984 5.83203H14.9998C15.4582 5.83203 15.8332 6.20703 15.8332 6.66536V16.6654C15.8332 17.1237 15.4582 17.4987 14.9998 17.4987Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6084_17779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitecopy);
export default __webpack_public_path__ + "static/media/invite copy.7acc6d6cdf4b0492247712ee664a6bc2.svg";
export { ForwardRef as ReactComponent };